import type { Template } from "@/types";

export const PO_07_H7_V0: Template[] = [
    {
        id: "po-07-h7v0-01",
        name: "PO 01 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_01.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 44, y: 235, width: 277, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 418, width: 277, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 329, y: 235, width: 277, height: 175, rotation: 0, imageRotation: 0 },
            { id: "4", x: 329, y: 418, width: 277, height: 175, rotation: 0, imageRotation: 0 },
            { id: "5", x: 729, y: 176, width: 484, height: 312, rotation: 0, imageRotation: 0 },
            { id: "6", x: 729, y: 496, width: 239, height: 155, rotation: 0, imageRotation: 0 },
            { id: "7", x: 976, y: 496, width: 238, height: 155, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-02",
        name: "PO 02 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 66, y: 249, width: 516, height: 327, rotation: 0, imageRotation: 0 },
            { id: "2", x: 722, y: 167, width: 254, height: 159, rotation: 0, imageRotation: 0 },
            { id: "3", x: 722, y: 334, width: 254, height: 159, rotation: 0, imageRotation: 0 },
            { id: "4", x: 722, y: 501, width: 254, height: 158, rotation: 0, imageRotation: 0 },
            { id: "5", x: 984, y: 167, width: 254, height: 159, rotation: 0, imageRotation: 0 },
            { id: "6", x: 984, y: 334, width: 254, height: 159, rotation: 0, imageRotation: 0 },
            { id: "7", x: 984, y: 501, width: 254, height: 158, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-03",
        name: "PO 03 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 62, y: 177, width: 553, height: 350, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 62, y: 534, width: 179, height: 116, rotation: 0, imageRotation: 0 },
            { id: "3", x: 249, y: 534, width: 179, height: 116, rotation: 0, imageRotation: 0 },
            { id: "4", x: 436, y: 534, width: 179, height: 116, rotation: 0, imageRotation: 0 },
            { id: "5", x: 700, y: 150, width: 553, height: 340, rotation: 0, imageRotation: 0 },
            { id: "6", x: 700, y: 497, width: 273, height: 180, rotation: 0, imageRotation: 0 },
            { id: "7", x: 981, y: 497, width: 272, height: 180, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-04",
        name: "PO 04 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 41, y: 234, width: 566, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 690, y: 234, width: 184, height: 114, rotation: 0, imageRotation: 0 },
            { id: "3", x: 690, y: 356, width: 184, height: 114, rotation: 0, imageRotation: 0 },
            { id: "4", x: 690, y: 478, width: 184, height: 114, rotation: 0, imageRotation: 0 },
            { id: "5", x: 882, y: 234, width: 184, height: 114, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1074, y: 234, width: 184, height: 114, rotation: 0, imageRotation: 0 },
            { id: "7", x: 882, y: 356, width: 376, height: 236, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-05",
        name: "PO 05 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 73, y: 159, width: 572, height: 353, rotation: 0, imageRotation: 0 },
            { id: "2", x: 653, y: 159, width: 572, height: 353, rotation: 0, imageRotation: 0 },
            { id: "3", x: 73, y: 520, width: 224, height: 147, rotation: 0, imageRotation: 0 },
            { id: "4", x: 305, y: 520, width: 224, height: 147, rotation: 0, imageRotation: 0 },
            { id: "5", x: 537, y: 520, width: 224, height: 147, rotation: 0, imageRotation: 0 },
            { id: "6", x: 769, y: 520, width: 224, height: 147, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1001, y: 520, width: 224, height: 147, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-06",
        name: "PO 06 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 56, y: 190, width: 291, height: 188, rotation: 0, imageRotation: 0 },
            { id: "2", x: 355, y: 190, width: 291, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 190, width: 291, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 953, y: 190, width: 290, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 56, y: 386, width: 390, height: 251, rotation: 0, imageRotation: 0 },
            { id: "6", x: 454, y: 386, width: 390, height: 251, rotation: 0, imageRotation: 0 },
            { id: "7", x: 852, y: 386, width: 390, height: 251, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-07",
        name: "PO 07 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_07.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 0, y: 199, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 345, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 0, y: 491, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 218, y: 491, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 436, y: 491, width: 209, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 218, y: 199, width: 427, height: 284, rotation: 0, imageRotation: 0 },
            { id: "7", x: 653, y: 199, width: 645, height: 430, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-08",
        name: "PO 08 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 199, width: 645, height: 430, rotation: 0, imageRotation: 0 },
            { id: "2", x: 653, y: 199, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 653, y: 345, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 491, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 871, y: 491, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1089, y: 491, width: 209, height: 138, rotation: 0, imageRotation: 0 },
            { id: "7", x: 871, y: 199, width: 427, height: 284, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-09",
        name: "PO 09 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 199, width: 645, height: 430, rotation: 0, imageRotation: 0 },
            { id: "2", x: 653, y: 199, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 871, y: 199, width: 210, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1089, y: 199, width: 209, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1089, y: 345, width: 209, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1089, y: 491, width: 209, height: 138, rotation: 0, imageRotation: 0 },
            { id: "7", x: 653, y: 345, width: 428, height: 284, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h7v0-10",
        name: "PO 10 - H7V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h7_v0_10.png",
        size: [1298, 827],
        style: {},
        slots: [
           
            { id: "2", x: 50, y: 178, width: 243, height: 152, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 338, width: 243, height: 151, rotation: 0, imageRotation: 0 },
            { id: "4", x: 50, y: 497, width: 243, height: 151, rotation: 0, imageRotation: 0 },
            { id: "1", x: 301, y: 178, width: 697, height: 470, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1006, y: 178, width: 242, height: 152, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1006, y: 338, width: 242, height: 151, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1006, y: 497, width: 242, height: 151, rotation: 0, imageRotation: 0 }
        ],
    }
];